const storagePrefix = '@rick0785:react-agenta-ts';

export const Storages = {
  USER: `${storagePrefix}:user`,
};
